import { render, staticRenderFns } from "./KpiItem.vue?vue&type=template&id=c9734232&scoped=true"
import script from "./KpiItem.vue?vue&type=script&lang=js"
export * from "./KpiItem.vue?vue&type=script&lang=js"
import style0 from "./KpiItem.vue?vue&type=style&index=0&id=c9734232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9734232",
  null
  
)

export default component.exports